module.exports = __webpack_public_path__ + "assets/students-class.050a2945.svg";